import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { LOGISTICS_VEHICLE_READ } from '~/components/routes/logistics/tabs'
import {
  LogisticsRecordRoute,
  logisticsRecordIdParam,
} from '~/components/routes/logistics/logistics-record-page'
import { VehiclePage } from '~/components/routes/logistics/vehicle-page'
import { withRoutePermissions } from '~/utils/rbac'
import { logisticsRecordSearch, recordOriginOf } from '../-record-origin'

export const Route = createFileRoute('/_authenticated/logistics/vehicles/$vehicleId')({
  staticData: {
    permission: LOGISTICS_VEHICLE_READ,
  },
  component: VehicleDetailRoute,
  params: {
    parse: z.object({ vehicleId: logisticsRecordIdParam() }).parse,
  },
  // Mêmes paramètres que la page Logistique : les filtres de la liste suivent l'aller-retour. Et
  // l'écran d'origine (`returnTo`), où ramène le retour de la fiche (LU-181).
  validateSearch: logisticsRecordSearch,
})
withRoutePermissions(Route)

function VehicleDetailRoute() {
  const { vehicleId } = Route.useParams()
  // L'origine reste à la fiche : changer d'onglet ou revenir à la liste ne la reporte pas.
  const { returnTo, ...search } = Route.useSearch()
  const origin = recordOriginOf(returnTo)
  return (
    <LogisticsRecordRoute tab="vehicles" search={search} permission={LOGISTICS_VEHICLE_READ}>
      {(search) => <VehiclePage vehicleId={vehicleId} search={search} origin={origin} />}
    </LogisticsRecordRoute>
  )
}
